import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Settings2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { api, isManagerRole } from "@/lib/api";
import { RidesTab } from "@/components/boy/panel/RidesTab";
import { CouriersTab } from "@/components/boy/panel/CouriersTab";
import { MerchantsTab } from "@/components/boy/panel/MerchantsTab";
import { FeesTab } from "@/components/boy/panel/FeesTab";

function BoyAlerts({ s }) {
  if (!s) return null;
  const c = s.config;
  const items = [
    !s.whatsapp && ["whatsapp", "Conecte o WhatsApp da empresa em Configurações → WhatsApp Bot para os motoboys receberem as corridas."],
    !s.payment.own && !s.payment.oauth.connected && ["mp", "Configure o Mercado Pago em Sistema → Minha empresa → Formas de pagamento para os lojistas pagarem as corridas."],
    !(c.price_per_km > 0 || c.min_price > 0 || c.radii.length) && ["price", "Defina os valores das corridas em Boy Express → Configurações."],
  ].filter(Boolean);
  if (!items.length) return null;
  return (
    <div className="space-y-2" data-testid="boy-alerts">
      {items.map(([k, text]) => (
        <p key={k} className="flex items-start gap-2 rounded-lg border border-amber-500/30 bg-amber-500/10 p-3 text-sm text-amber-800 dark:text-amber-200" data-testid={`boy-alert-${k}`}>
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />{text}
        </p>
      ))}
    </div>
  );
}

export default function BoyExpress() {
  const { session } = useAuth();
  const mgr = isManagerRole(session.user);
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/boy/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);
  return (
    <div className="space-y-6" data-testid="boy-express-page">
      <PageHeader eyebrow="Boy Express" title="Corridas e cadastros" subtitle="Acompanhe as corridas pedidas pelos lojistas e aprove os motoboys."
        actions={mgr && <Button asChild variant="outline"><Link to="/app/boy-express/config" data-testid="boy-open-config-btn"><Settings2 className="mr-2 h-4 w-4" />Configurações</Link></Button>} />
      <BoyAlerts s={s} />
      <Tabs defaultValue="corridas">
        <TabsList className="h-auto flex-wrap">
          <TabsTrigger value="corridas" data-testid="boy-tab-corridas">Corridas</TabsTrigger>
          <TabsTrigger value="motoboys" data-testid="boy-tab-motoboys">Motoboys</TabsTrigger>
          <TabsTrigger value="lojistas" data-testid="boy-tab-lojistas">Lojistas</TabsTrigger>
          <TabsTrigger value="taxas" data-testid="boy-tab-taxas">Taxas da plataforma</TabsTrigger>
        </TabsList>
        <TabsContent value="corridas" className="mt-4"><RidesTab /></TabsContent>
        <TabsContent value="motoboys" className="mt-4"><CouriersTab mgr={mgr} /></TabsContent>
        <TabsContent value="lojistas" className="mt-4"><MerchantsTab /></TabsContent>
        <TabsContent value="taxas" className="mt-4"><FeesTab mgr={mgr} /></TabsContent>
      </Tabs>
    </div>
  );
}
